import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getAuth } from 'firebase/auth';
import './WaitingRoom.css';

function WaitingRoom() {
  const { sessionId } = useParams();
  const [countdown, setCountdown] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSession = async () => {
      const auth = getAuth();
      const token = await auth.currentUser.getIdToken();

      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/sessions/${sessionId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        const startTime = typeof res.data.startsAt === 'object' && res.data.startsAt.toMillis
          ? res.data.startsAt.toMillis()
          : res.data.startsAt;

        const waitTime = startTime - Date.now();
        const seconds = Math.max(Math.floor(waitTime / 1000), 0);
        setCountdown(seconds);

        if (waitTime > 0) {
          setTimeout(() => navigate(`/dashboard/video/${sessionId}`), waitTime);
        } else {
          navigate(`/dashboard/video/${sessionId}`);
        }
      } catch (err) {
        console.error('Error fetching session start time:', err);
      }
    };

    fetchSession();
  }, [sessionId, navigate]);

  useEffect(() => {
    if (countdown === null) return;

    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev === 1) {
          clearInterval(timer);
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [countdown]);

  return (
    <div className="waiting-room">
      <div className="waiting-content">
        <h2>Your session will begin shortly</h2>
        {countdown !== null ? (
          <div className="countdown-box">
            <div className="countdown-number">{countdown}</div>
            <div className="countdown-label">seconds remaining</div>
          </div>
        ) : (
          <p>Fetching session time...</p>
        )}
        <p>Please do not leave this page. You'll be redirected automatically.</p>
      </div>
    </div>
  );
}

export default WaitingRoom;